import { everest } from '~/services/serviceInstances';

export interface SupplierContactAttributes {
  name: string;
  first_name: string;
  last_name: string;
  email: string;
  contact_types?: Array<{ id: number; name: string }>;
}

export interface SupplierContact {
  type: 'supplier_contacts';
  id: string;
  attributes: SupplierContactAttributes;
}

export interface SupplierCompanyAttributes {
  wid?: string;
  name: string;
  external_status?: string;
  segmentation?: string;
  risk?: string;
}

export interface SupplierCompanyData {
  type: 'supplier_companies';
  id: string;
  attributes: SupplierCompanyAttributes;
}

export interface GetSupplierCompanyResponse {
  data: SupplierCompanyData;
  included?: SupplierContact[];
}

type Request = {
  supplierId: string;
  includeContacts?: boolean;
};

export const getSupplierCompany = async ({
  supplierId,
  includeContacts = true,
}: Request): Promise<GetSupplierCompanyResponse> => {
  return everest.get(`/suppliers/${supplierId}`, {
    params: { include_contacts: JSON.stringify(includeContacts) },
  });
};
